import type { ComponentProps, PropsWithChildren, ReactNode } from 'react'
import {
  Card as BaseCard,
  CardAction,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from './ui/card'
import { cn } from '@/lib/utils'

interface Props
  extends PropsWithChildren,
    Omit<ComponentProps<'div'>, 'title'> {
  contentClassName?: string

  title?: ReactNode
  description?: ReactNode
  action?: ReactNode
  footer?: ReactNode
}

export function Card({
  children,
  className,
  contentClassName,

  title,
  description,
  action,
  footer,
}: Props) {
  return (
    <BaseCard className={cn('gap-0', className)}>
      {!!title && (
        <CardHeader>
          <CardTitle>{title}</CardTitle>

          {!!description && <CardDescription>{description}</CardDescription>}

          {!!action && <CardAction>{action}</CardAction>}
        </CardHeader>
      )}

      <CardContent className={contentClassName}>{children}</CardContent>

      {!!footer && <CardFooter>{footer}</CardFooter>}
    </BaseCard>
  )
}
